import { ResponseSignInDto } from "@/dtos";

export const authHeader = () => {
    const userData = JSON.parse(localStorage.getItem('administrator') || '') as ResponseSignInDto;
    return { 'Authorization': (userData) ? 'Bearer ' + userData.access_token : '' };
}